var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sdk-input',{attrs:{"placeholder":"9876 5432 1098 7654"},on:{"blur":_vm.onBlur,"focus":_vm.onFocus,"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }